// Top stats bar — flag picker on the left, streak/gems/hearts on the right.

import CroFlag from './CroFlag.jsx';
import { Icons } from './Icons.jsx';
import { BALL } from '../theme.js';

function StatPill({ icon, value, theme = BALL }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 5,
      fontWeight: 900, color: theme.ink, fontSize: 17,
    }}>
      <span style={{ display: 'inline-flex' }}>{icon}</span>
      <span style={{ fontVariantNumeric: 'tabular-nums' }}>{value}</span>
    </div>
  );
}

export default function TopStatsBar({ streak = 0, gems = 0, theme = BALL, onSettings }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: 'calc(env(safe-area-inset-top) + 12px) 18px 14px',
      background: theme.bgAlt,
      borderBottom: `1px solid ${theme.hairline}`,
    }}>
      <button type="button" onClick={onSettings} style={{
        appearance: 'none', background: 'none', border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', gap: 6, padding: 0,
      }}>
        <CroFlag size={32} />
        <svg width="10" height="10" viewBox="0 0 10 10">
          <path d="M2 3 L5 6 L8 3" stroke={theme.inkSoft} strokeWidth="1.5" fill="none" strokeLinecap="round" />
        </svg>
      </button>
      <div style={{ display: 'flex', alignItems: 'center', gap: 18 }}>
        <StatPill icon={Icons.flame()} value={streak} theme={theme} />
        <StatPill icon={Icons.gem()} value={gems} theme={theme} />
      </div>
    </div>
  );
}
